import axios from '../config/axios';
import {actions as A} from '../constants/actions';
import {setRequestId} from "../utils/setRequestId";

export const checkAgentId = ({regType}) => {
  return (dispatch) => {
    dispatch({
      type: A.CHECK_AGENT_ID
    });
    setRequestId();

    const data = {regType};

    return axios.post('/regGeneral/checkAgentId', data)
      .then((response) => {
        const {data} = response.data;
        const {agentId} = data;
        dispatch({
          type: A.CHECK_AGENT_ID_SUCCESS,
          payload: {agentId}
        });

        return agentId;
      })
      .catch((err) => {
        return dispatch({
          type: A.CHECK_AGENT_ID_FAILURE,
          payload: {errorMessage: err.message}
        })
      });
  };
};
